export const QUERIES = {
	products: {
		variables: { first: 100 },
	},
};
